// @ts-nocheck
(function () {
  'use strict';

  class QuizResults {
    constructor(sectionId, fallbackThreshold) {
      this.sectionId = sectionId;
      this.loadingEl = document.getElementById('qr-loading-' + sectionId);
      this.emptyEl   = document.getElementById('qr-empty-'   + sectionId);
      this.gridEl    = document.getElementById('qr-grid-'    + sectionId);
      this.answersEl = document.getElementById('qr-answers-' + sectionId);
      this.fallbackThreshold = parseInt(fallbackThreshold, 10);
      if (isNaN(this.fallbackThreshold)) this.fallbackThreshold = 2;

      this._renderAnswers();

      if (!this.loadingEl || !this.emptyEl || !this.gridEl) return;

      this.vals = this._getUrlValues();
      this._render();
    }

    _getResultsTags() {
      var raw = new URLSearchParams(window.location.search).get('rt') || '';
      if (!raw) return [];
      try {
        var parsed = JSON.parse(decodeURIComponent(raw));
        return Array.isArray(parsed) ? parsed : [];
      } catch (e) {
        return [];
      }
    }

    _renderAnswers() {
      if (!this.answersEl) return;

      var tags = this._getResultsTags();
      if (!tags.length) return;

      this.answersEl.innerHTML = tags.map(function (item) {
        var tag    = item && item.tag    ? String(item.tag)    : '';
        var answer = item && item.answer ? String(item.answer) : '';
        if (!answer) return '';

        var label = document.createElement('span');
        label.className = 'qr-header__answer-label';
        label.textContent = tag ? tag + ': ' : '';

        var value = document.createElement('span');
        value.className = 'qr-header__answer-value';
        value.textContent = answer;

        var wrap = document.createElement('h2');
        wrap.className = 'qr-header__answer';
        wrap.appendChild(label);
        wrap.appendChild(value);

        return wrap.outerHTML;
      }).filter(Boolean).join('');
    }

    _getUrlValues() {
      var raw = new URLSearchParams(window.location.search).get('v') || '';
      return raw.split(',').map(function (v) { return decodeURIComponent(v.trim()); }).filter(Boolean);
    }

    _matchesAll(li) {
      var raw = li.dataset.mf;
      if (!raw || raw === 'null') return false;
      var mf;
      try { mf = JSON.parse(raw); } catch (e) { mf = raw; }
      var mfArr = Array.isArray(mf) ? mf : [String(mf)];
      return this.vals.every(function (v) { return mfArr.indexOf(v) !== -1; });
    }

    _showEmpty() {
      this.emptyEl.style.display = '';
    }

    _render() {
      this.loadingEl.style.display = 'none';

      var matched = this.vals.length
        ? Array.from(this.gridEl.querySelectorAll('.qr-item:not(.qr-item--fallback)')).filter(this._matchesAll.bind(this))
        : [];
      var fallbackItems = Array.from(this.gridEl.querySelectorAll('.qr-item--fallback'));

      // Above the threshold: show only the matched products.
      if (matched.length > this.fallbackThreshold) {
        matched.forEach(function (li) { li.style.display = ''; });
        this.gridEl.style.display = '';
        return;
      }

      // At or below the threshold: pad out the grid with the configured fallback products.
      if (fallbackItems.length) {
        matched.forEach(function (li) { li.style.display = ''; });
        fallbackItems.forEach(function (li) { li.style.display = ''; });
        this.gridEl.style.display = '';
        return;
      }

      if (!matched.length) { this._showEmpty(); return; }

      matched.forEach(function (li) { li.style.display = ''; });
      this.gridEl.style.display = '';
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-quiz-results-id]').forEach(function (el) {
      new QuizResults(el.dataset.quizResultsId, el.dataset.fallbackThreshold);
    });
  });
})();
